import Cancel from '@eduzz/houston-icons/Cancel';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useTheme from '@material-ui/core/styles/useTheme';
import Tooltip from '@material-ui/core/Tooltip';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import type { ReactNode } from 'react';
import React from 'react';

import styles from './styles';

interface ModalProps {
  open: boolean;
  keepMounted?: boolean;
  size?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  textTitle: string;
  textReturnButton: string;
  textProceedButton?: string | JSX.Element;
  hideReturnButton?: boolean;
  hideProceedButton?: boolean;
  isProceedButtonDisabled?: boolean;
  enableScroll?: boolean;
  children: ReactNode;
  setClose: () => void;
  handleProceedClick?: (any: any) => void;
  handleReturnClick?: (any: any) => void;
  textTooltipProceedButton?: string;
}

function Modal({
  open,
  keepMounted,
  size = 'sm',
  textTitle,
  textReturnButton,
  textProceedButton,
  children,
  textTooltipProceedButton,
  isProceedButtonDisabled = false,
  hideReturnButton = false,
  hideProceedButton = false,
  enableScroll = false,
  setClose,
  handleProceedClick,
  handleReturnClick = setClose,
}: ModalProps) {
  const classes = styles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      keepMounted={keepMounted}
      onClose={setClose}
      open={open}
      className={classes.modal}
      PaperProps={{ className: classes.paper }}
      fullWidth
      maxWidth={size}
      fullScreen={isMobile}
      disableRestoreFocus
    >
      <DialogTitle className={classes.title} disableTypography>
        <span>{textTitle}</span>
        <Box onClick={setClose} id='modal-close-button' className={classes.closeButton}>
          <Cancel />
        </Box>
      </DialogTitle>
      <DialogContent style={{ overflowY: enableScroll || isMobile ? 'auto' : 'visible' }}>
        <DialogContentText className={classes.boxContentText}>{children}</DialogContentText>
      </DialogContent>
      <DialogActions className={classes.buttonGroup}>
        {!hideReturnButton && (
          <Button variant='text' id='modal-return-button' onClick={handleReturnClick} className={classes.returnButton}>
            {textReturnButton}
          </Button>
        )}
        {!hideProceedButton &&
          (textTooltipProceedButton ? (
            <Tooltip title={textTooltipProceedButton} placement='top'>
              <Button
                type='submit'
                variant='contained'
                id='modal-proceed-button'
                onClick={handleProceedClick}
                className={classes.proceedButton}
                disabled={isProceedButtonDisabled}
              >
                {textProceedButton}
              </Button>
            </Tooltip>
          ) : (
            <Button
              type='submit'
              variant='contained'
              color='primary'
              id='modal-proceed-button'
              onClick={handleProceedClick}
              className={classes.proceedButton}
              disabled={isProceedButtonDisabled}
            >
              {textProceedButton}
            </Button>
          ))}
      </DialogActions>
    </Dialog>
  );
}

export default Modal;
